'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotBarAxesIcon = function PlotBarAxesIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 0h1.625v32H0zm32 30.375V32H0v-1.625zM3.188 12.813h3.188v16H3.188zM8 11.188h3.188v17.625H8zm4.813 1.625h3.188v16h-3.188zm4.812-3.188h3.188v19.188h-3.188zM22.375 8h3.25v20.813h-3.25zm4.813-3.187h3.188v24h-3.188z' })
    );
};

exports.default = PlotBarAxesIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotBarAxesIcon.js
// module id = 646
// module chunks = 0